import { render, staticRenderFns } from "./BlacklistHistories.vue?vue&type=template&id=0d8bd3e4&"
import script from "./BlacklistHistories.vue?vue&type=script&lang=js&"
export * from "./BlacklistHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports